const supplementalProblems = [
  {
    id: 'sqrt',
    aliases: ['sqrtx'],
    title: 'Sqrt(x)',
    difficulty: 'Easy',
    prompt: 'Given a non-negative integer x, return the integer square root of x. The result should be rounded down to the nearest integer.',
    signature: { args: [{ name: 'x', type: 'int' }], returns: 'int' },
    examples: [{ input: { x: 8 }, output: 2 }],
    tests: [
      { input: { x: 0 }, expected: 0 },
      { input: { x: 1 }, expected: 1 },
      { input: { x: 4 }, expected: 2 },
      { input: { x: 8 }, expected: 2 },
      { input: { x: 2147395599 }, expected: 46339 },
    ],
  },
  {
    id: 'fizz-buzz',
    title: 'Fizz Buzz',
    difficulty: 'Easy',
    prompt: 'Return the Fizz Buzz sequence from 1 to n. Use "Fizz" for multiples of 3, "Buzz" for multiples of 5, and "FizzBuzz" for both.',
    signature: { args: [{ name: 'n', type: 'int' }], returns: 'stringArray' },
    examples: [{ input: { n: 5 }, output: ['1', '2', 'Fizz', '4', 'Buzz'] }],
    tests: [
      { input: { n: 1 }, expected: ['1'] },
      { input: { n: 5 }, expected: ['1', '2', 'Fizz', '4', 'Buzz'] },
      { input: { n: 15 }, expected: ['1', '2', 'Fizz', '4', 'Buzz', 'Fizz', '7', '8', 'Fizz', 'Buzz', '11', 'Fizz', '13', '14', 'FizzBuzz'] },
    ],
  },
  {
    id: 'reverse-string',
    title: 'Reverse String',
    difficulty: 'Easy',
    prompt: 'Given an array of characters, return the characters in reverse order.',
    signature: { args: [{ name: 's', type: 'stringArray' }], returns: 'stringArray' },
    examples: [{ input: { s: ['h', 'e', 'l', 'l', 'o'] }, output: ['o', 'l', 'l', 'e', 'h'] }],
    tests: [
      { input: { s: ['h', 'e', 'l', 'l', 'o'] }, expected: ['o', 'l', 'l', 'e', 'h'] },
      { input: { s: ['H', 'a', 'n', 'n', 'a', 'h'] }, expected: ['h', 'a', 'n', 'n', 'a', 'H'] },
      { input: { s: ['a'] }, expected: ['a'] },
    ],
  },
  {
    id: 'longest-common-prefix',
    title: 'Longest Common Prefix',
    difficulty: 'Easy',
    prompt: 'Given an array of strings, return the longest prefix shared by every string. Return an empty string if none exists.',
    signature: { args: [{ name: 'strs', type: 'stringArray' }], returns: 'string' },
    examples: [{ input: { strs: ['flower', 'flow', 'flight'] }, output: 'fl' }],
    tests: [
      { input: { strs: ['flower', 'flow', 'flight'] }, expected: 'fl' },
      { input: { strs: ['dog', 'racecar', 'car'] }, expected: '' },
      { input: { strs: ['interspecies', 'interstellar', 'interstate'] }, expected: 'inters' },
      { input: { strs: ['alone'] }, expected: 'alone' },
    ],
  },
  {
    id: 'power-of-three',
    title: 'Power of Three',
    difficulty: 'Easy',
    prompt: 'Return true if n is a positive power of three.',
    signature: { args: [{ name: 'n', type: 'int' }], returns: 'bool' },
    examples: [{ input: { n: 27 }, output: true }],
    tests: [
      { input: { n: 27 }, expected: true },
      { input: { n: 0 }, expected: false },
      { input: { n: 9 }, expected: true },
      { input: { n: 45 }, expected: false },
      { input: { n: 1 }, expected: true },
    ],
  },
  {
    id: 'number-of-1-bits',
    aliases: ['number-of-one-bits'],
    title: 'Number of 1 Bits',
    difficulty: 'Easy',
    prompt: 'Return the number of set bits in the unsigned binary representation of n.',
    signature: { args: [{ name: 'n', type: 'int' }], returns: 'int' },
    examples: [{ input: { n: 11 }, output: 3 }],
    tests: [
      { input: { n: 11 }, expected: 3 },
      { input: { n: 128 }, expected: 1 },
      { input: { n: 2147483645 }, expected: 30 },
      { input: { n: 0 }, expected: 0 },
    ],
  },
  {
    id: 'range-sum-query-immutable',
    title: 'Range Sum Query - Immutable',
    difficulty: 'Easy',
    prompt: 'Given nums and a list of [left, right] queries, return the sum inside each inclusive range.',
    signature: { args: [{ name: 'nums', type: 'intArray' }, { name: 'queries', type: 'intMatrix' }], returns: 'intArray' },
    examples: [{ input: { nums: [-2, 0, 3, -5, 2, -1], queries: [[0, 2], [2, 5], [0, 5]] }, output: [1, -1, -3] }],
    tests: [
      { input: { nums: [-2, 0, 3, -5, 2, -1], queries: [[0, 2], [2, 5], [0, 5]] }, expected: [1, -1, -3] },
      { input: { nums: [1, 2, 3, 4], queries: [[1, 3], [0, 0]] }, expected: [9, 1] },
    ],
  },
  {
    id: 'fibonacci-number',
    title: 'Fibonacci Number',
    difficulty: 'Easy',
    prompt: 'Return the nth Fibonacci number where F(0) = 0 and F(1) = 1.',
    signature: { args: [{ name: 'n', type: 'int' }], returns: 'int' },
    examples: [{ input: { n: 4 }, output: 3 }],
    tests: [
      { input: { n: 0 }, expected: 0 },
      { input: { n: 1 }, expected: 1 },
      { input: { n: 4 }, expected: 3 },
      { input: { n: 10 }, expected: 55 },
      { input: { n: 30 }, expected: 832040 },
    ],
  },
  {
    id: 'min-cost-climbing-stairs',
    title: 'Min Cost Climbing Stairs',
    difficulty: 'Easy',
    prompt: 'Given the cost of each stair, return the minimum cost to reach the top. You may climb one or two steps at a time.',
    signature: { args: [{ name: 'cost', type: 'intArray' }], returns: 'int' },
    examples: [{ input: { cost: [10, 15, 20] }, output: 15 }],
    tests: [
      { input: { cost: [10, 15, 20] }, expected: 15 },
      { input: { cost: [1, 100, 1, 1, 1, 100, 1, 1, 100, 1] }, expected: 6 },
      { input: { cost: [0, 0, 0, 1] }, expected: 0 },
    ],
  },
  {
    id: 'minimum-add-to-make-parentheses-valid',
    title: 'Minimum Add to Make Parentheses Valid',
    difficulty: 'Medium',
    prompt: 'Return the minimum number of parentheses that must be added to make s valid.',
    signature: { args: [{ name: 's', type: 'string' }], returns: 'int' },
    examples: [{ input: { s: '())' }, output: 1 }],
    tests: [
      { input: { s: '())' }, expected: 1 },
      { input: { s: '(((' }, expected: 3 },
      { input: { s: '()' }, expected: 0 },
      { input: { s: '()))((' }, expected: 4 },
    ],
  },
  {
    id: 'longest-palindromic-substring',
    title: 'Longest Palindromic Substring',
    difficulty: 'Medium',
    prompt: 'Return the longest palindromic substring in s. If multiple answers exist, return any one of them.',
    signature: { args: [{ name: 's', type: 'string' }], returns: 'string' },
    examples: [{ input: { s: 'babad' }, output: 'bab' }],
    tests: [
      { input: { s: 'babad' }, expected: 'bab' },
      { input: { s: 'cbbd' }, expected: 'bb' },
      { input: { s: 'a' }, expected: 'a' },
      { input: { s: 'racecar' }, expected: 'racecar' },
    ],
  },
  {
    id: 'two-sum-ii-input-array-is-sorted',
    title: 'Two Sum II - Input Array Is Sorted',
    difficulty: 'Medium',
    prompt: 'Given a 1-indexed sorted array, return the two indices whose values add up to target.',
    signature: { args: [{ name: 'numbers', type: 'intArray' }, { name: 'target', type: 'int' }], returns: 'intArray' },
    examples: [{ input: { numbers: [2, 7, 11, 15], target: 9 }, output: [1, 2] }],
    tests: [
      { input: { numbers: [2, 7, 11, 15], target: 9 }, expected: [1, 2] },
      { input: { numbers: [2, 3, 4], target: 6 }, expected: [1, 3] },
      { input: { numbers: [-1, 0], target: -1 }, expected: [1, 2] },
    ],
  },
  {
    id: 'container-with-most-water',
    title: 'Container With Most Water',
    difficulty: 'Medium',
    prompt: 'Given vertical line heights, return the maximum amount of water a pair of lines can contain.',
    signature: { args: [{ name: 'height', type: 'intArray' }], returns: 'int' },
    examples: [{ input: { height: [1, 8, 6, 2, 5, 4, 8, 3, 7] }, output: 49 }],
    tests: [
      { input: { height: [1, 8, 6, 2, 5, 4, 8, 3, 7] }, expected: 49 },
      { input: { height: [1, 1] }, expected: 1 },
      { input: { height: [4, 3, 2, 1, 4] }, expected: 16 },
    ],
  },
  {
    id: '3sum',
    aliases: ['three-sum'],
    title: '3Sum',
    difficulty: 'Medium',
    prompt: 'Return all unique triplets that sum to zero. Return triplets and the outer list in ascending lexicographic order.',
    signature: { args: [{ name: 'nums', type: 'intArray' }], returns: 'intMatrix' },
    examples: [{ input: { nums: [-1, 0, 1, 2, -1, -4] }, output: [[-1, -1, 2], [-1, 0, 1]] }],
    tests: [
      { input: { nums: [-1, 0, 1, 2, -1, -4] }, expected: [[-1, -1, 2], [-1, 0, 1]] },
      { input: { nums: [0, 1, 1] }, expected: [] },
      { input: { nums: [0, 0, 0] }, expected: [[0, 0, 0]] },
      { input: { nums: [-2, 0, 1, 1, 2] }, expected: [[-2, 0, 2], [-2, 1, 1]] },
    ],
  },
  {
    id: 'group-anagrams',
    title: 'Group Anagrams',
    difficulty: 'Medium',
    prompt: 'Group anagrams together. Return each group sorted internally, and return groups ordered by their first string.',
    signature: { args: [{ name: 'strs', type: 'stringArray' }], returns: 'intMatrix' },
    examples: [{ input: { strs: ['eat', 'tea', 'tan', 'ate', 'nat', 'bat'] }, output: [[0, 1, 3], [2, 4], [5]] }],
    tests: [
      { input: { strs: ['eat', 'tea', 'tan', 'ate', 'nat', 'bat'] }, expected: [[0, 1, 3], [2, 4], [5]] },
      { input: { strs: [''] }, expected: [[0]] },
      { input: { strs: ['a'] }, expected: [[0]] },
    ],
  },
  {
    id: 'kth-largest-element-in-an-array',
    title: 'Kth Largest Element in an Array',
    difficulty: 'Medium',
    prompt: 'Return the kth largest value in nums.',
    signature: { args: [{ name: 'nums', type: 'intArray' }, { name: 'k', type: 'int' }], returns: 'int' },
    examples: [{ input: { nums: [3, 2, 1, 5, 6, 4], k: 2 }, output: 5 }],
    tests: [
      { input: { nums: [3, 2, 1, 5, 6, 4], k: 2 }, expected: 5 },
      { input: { nums: [3, 2, 3, 1, 2, 4, 5, 5, 6], k: 4 }, expected: 4 },
      { input: { nums: [1], k: 1 }, expected: 1 },
    ],
  },
  {
    id: 'k-closest-points-to-origin',
    title: 'K Closest Points to Origin',
    difficulty: 'Medium',
    prompt: 'Given points [x, y], return the k closest points to the origin sorted lexicographically.',
    signature: { args: [{ name: 'points', type: 'intMatrix' }, { name: 'k', type: 'int' }], returns: 'intMatrix' },
    examples: [{ input: { points: [[1, 3], [-2, 2]], k: 1 }, output: [[-2, 2]] }],
    tests: [
      { input: { points: [[1, 3], [-2, 2]], k: 1 }, expected: [[-2, 2]] },
      { input: { points: [[3, 3], [5, -1], [-2, 4]], k: 2 }, expected: [[-2, 4], [3, 3]] },
    ],
  },
  {
    id: 'first-bad-version',
    title: 'First Bad Version',
    difficulty: 'Easy',
    prompt: 'Given n and the first bad version value, return the first bad version using the least number of checks.',
    signature: { args: [{ name: 'n', type: 'int' }, { name: 'bad', type: 'int' }], returns: 'int' },
    examples: [{ input: { n: 5, bad: 4 }, output: 4 }],
    tests: [
      { input: { n: 5, bad: 4 }, expected: 4 },
      { input: { n: 1, bad: 1 }, expected: 1 },
      { input: { n: 100, bad: 37 }, expected: 37 },
    ],
  },
  {
    id: 'find-peak-element',
    title: 'Find Peak Element',
    difficulty: 'Medium',
    prompt: 'Return the index of any peak element. A peak is strictly greater than its neighbors.',
    signature: { args: [{ name: 'nums', type: 'intArray' }], returns: 'int' },
    examples: [{ input: { nums: [1, 2, 3, 1] }, output: 2 }],
    tests: [
      { input: { nums: [1, 2, 3, 1] }, expected: 2 },
      { input: { nums: [1] }, expected: 0 },
      { input: { nums: [1, 2, 1, 3, 5, 6, 4] }, expected: 5 },
    ],
  },
  {
    id: 'koko-eating-bananas',
    title: 'Koko Eating Bananas',
    difficulty: 'Medium',
    prompt: 'Given banana piles and h hours, return the minimum integer eating speed needed to finish in time.',
    signature: { args: [{ name: 'piles', type: 'intArray' }, { name: 'h', type: 'int' }], returns: 'int' },
    examples: [{ input: { piles: [3, 6, 7, 11], h: 8 }, output: 4 }],
    tests: [
      { input: { piles: [3, 6, 7, 11], h: 8 }, expected: 4 },
      { input: { piles: [30, 11, 23, 4, 20], h: 5 }, expected: 30 },
      { input: { piles: [30, 11, 23, 4, 20], h: 6 }, expected: 23 },
    ],
  },
];

const P = (id, title, difficulty, prompt, args, returns, input, output, tests, aliases = []) => ({
  id,
  aliases,
  title,
  difficulty,
  prompt,
  signature: { args, returns },
  examples: [{ input, output }],
  tests: tests.map(([testInput, expected]) => ({ input: testInput, expected })),
});

const A = {
  int: (name) => ({ name, type: 'int' }),
  double: (name) => ({ name, type: 'double' }),
  bool: (name) => ({ name, type: 'bool' }),
  string: (name) => ({ name, type: 'string' }),
  ints: (name) => ({ name, type: 'intArray' }),
  strings: (name) => ({ name, type: 'stringArray' }),
  matrix: (name) => ({ name, type: 'intMatrix' }),
};

supplementalProblems.push(
  P('search-insert-position', 'Search Insert Position', 'Easy', 'Given sorted nums and target, return the index if found or the insertion index if not found.', [A.ints('nums'), A.int('target')], 'int', { nums: [1, 3, 5, 6], target: 5 }, 2, [
    [{ nums: [1, 3, 5, 6], target: 5 }, 2],
    [{ nums: [1, 3, 5, 6], target: 2 }, 1],
    [{ nums: [1, 3, 5, 6], target: 7 }, 4],
  ]),
  P('find-first-and-last-position-of-element-in-sorted-array', 'Find First and Last Position of Element in Sorted Array', 'Medium', 'Given sorted nums and target, return the first and last target index, or [-1, -1] if missing.', [A.ints('nums'), A.int('target')], 'intArray', { nums: [5, 7, 7, 8, 8, 10], target: 8 }, [3, 4], [
    [{ nums: [5, 7, 7, 8, 8, 10], target: 8 }, [3, 4]],
    [{ nums: [5, 7, 7, 8, 8, 10], target: 6 }, [-1, -1]],
    [{ nums: [], target: 0 }, [-1, -1]],
  ]),
  P('3sum-closest', '3Sum Closest', 'Medium', 'Return the sum of three integers in nums closest to target.', [A.ints('nums'), A.int('target')], 'int', { nums: [-1, 2, 1, -4], target: 1 }, 2, [
    [{ nums: [-1, 2, 1, -4], target: 1 }, 2],
    [{ nums: [0, 0, 0], target: 1 }, 0],
    [{ nums: [1, 1, 1, 0], target: -100 }, 2],
  ]),
  P('continuous-subarray-sum', 'Continuous Subarray Sum', 'Medium', 'Return true if nums has a contiguous subarray of length at least two whose sum is a multiple of k.', [A.ints('nums'), A.int('k')], 'bool', { nums: [23, 2, 4, 6, 7], k: 6 }, true, [
    [{ nums: [23, 2, 4, 6, 7], k: 6 }, true],
    [{ nums: [23, 2, 6, 4, 7], k: 13 }, false],
    [{ nums: [5, 0, 0], k: 3 }, true],
  ]),
  P('count-number-of-nice-subarrays', 'Count Number of Nice Subarrays', 'Medium', 'Return the number of contiguous subarrays containing exactly k odd numbers.', [A.ints('nums'), A.int('k')], 'int', { nums: [1, 1, 2, 1, 1], k: 3 }, 2, [
    [{ nums: [1, 1, 2, 1, 1], k: 3 }, 2],
    [{ nums: [2, 4, 6], k: 1 }, 0],
    [{ nums: [2, 2, 2, 1, 2, 2, 1, 2, 2, 2], k: 2 }, 16],
  ]),
  P('maximum-product-subarray', 'Maximum Product Subarray', 'Medium', 'Return the maximum product of a non-empty contiguous subarray.', [A.ints('nums')], 'int', { nums: [2, 3, -2, 4] }, 6, [
    [{ nums: [2, 3, -2, 4] }, 6],
    [{ nums: [-2, 0, -1] }, 0],
    [{ nums: [-2, 3, -4] }, 24],
  ]),
  P('unique-paths', 'Unique Paths', 'Medium', 'Return the number of ways to move from the top-left to bottom-right of an m by n grid moving only right or down.', [A.int('m'), A.int('n')], 'int', { m: 3, n: 7 }, 28, [
    [{ m: 3, n: 7 }, 28],
    [{ m: 3, n: 2 }, 3],
    [{ m: 1, n: 10 }, 1],
  ]),
  P('minimum-path-sum', 'Minimum Path Sum', 'Medium', 'Given a non-negative grid, return the minimum path sum from top-left to bottom-right moving only right or down.', [A.matrix('grid')], 'int', { grid: [[1, 3, 1], [1, 5, 1], [4, 2, 1]] }, 7, [
    [{ grid: [[1, 3, 1], [1, 5, 1], [4, 2, 1]] }, 7],
    [{ grid: [[1, 2, 3], [4, 5, 6]] }, 12],
    [{ grid: [[5]] }, 5],
  ]),
  P('max-consecutive-ones-iii', 'Max Consecutive Ones III', 'Medium', 'Return the longest subarray containing only 1s after flipping at most k zeros.', [A.ints('nums'), A.int('k')], 'int', { nums: [1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 0], k: 2 }, 6, [
    [{ nums: [1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 0], k: 2 }, 6],
    [{ nums: [0, 0, 1, 1, 1, 0, 0], k: 0 }, 3],
    [{ nums: [0, 0, 0], k: 3 }, 3],
  ]),
  P('maximize-the-confusion-of-an-exam', 'Maximize the Confusion of an Exam', 'Medium', 'Given an answer key of T/F characters, return the longest run of equal answers after changing at most k characters.', [A.string('answerKey'), A.int('k')], 'int', { answerKey: 'TTFF', k: 2 }, 4, [
    [{ answerKey: 'TTFF', k: 2 }, 4],
    [{ answerKey: 'TFFT', k: 1 }, 3],
    [{ answerKey: 'TTFTTFTT', k: 1 }, 5],
  ]),
  P('longest-nice-subarray', 'Longest Nice Subarray', 'Medium', 'Return the length of the longest subarray where every pair of values has bitwise AND equal to zero.', [A.ints('nums')], 'int', { nums: [1, 3, 8, 48, 10] }, 3, [
    [{ nums: [1, 3, 8, 48, 10] }, 3],
    [{ nums: [3, 1, 5, 11, 13] }, 1],
    [{ nums: [2, 4, 8, 16] }, 4],
  ]),
  P('house-robber', 'House Robber', 'Medium', 'Return the maximum amount that can be robbed without robbing adjacent houses.', [A.ints('nums')], 'int', { nums: [1, 2, 3, 1] }, 4, [
    [{ nums: [1, 2, 3, 1] }, 4],
    [{ nums: [2, 7, 9, 3, 1] }, 12],
    [{ nums: [2, 1, 1, 2] }, 4],
  ]),
  P('longest-increasing-subsequence', 'Longest Increasing Subsequence', 'Medium', 'Return the length of the longest strictly increasing subsequence.', [A.ints('nums')], 'int', { nums: [10, 9, 2, 5, 3, 7, 101, 18] }, 4, [
    [{ nums: [10, 9, 2, 5, 3, 7, 101, 18] }, 4],
    [{ nums: [0, 1, 0, 3, 2, 3] }, 4],
    [{ nums: [7, 7, 7, 7] }, 1],
  ]),
  P('longest-common-subsequence', 'Longest Common Subsequence', 'Medium', 'Return the length of the longest subsequence common to text1 and text2.', [A.string('text1'), A.string('text2')], 'int', { text1: 'abcde', text2: 'ace' }, 3, [
    [{ text1: 'abcde', text2: 'ace' }, 3],
    [{ text1: 'abc', text2: 'abc' }, 3],
    [{ text1: 'abc', text2: 'def' }, 0],
  ]),
  P('best-time-to-buy-and-sell-stock-ii', 'Best Time to Buy and Sell Stock II', 'Medium', 'Return the maximum profit from as many buy-sell transactions as you want, holding at most one share at a time.', [A.ints('prices')], 'int', { prices: [7, 1, 5, 3, 6, 4] }, 7, [
    [{ prices: [7, 1, 5, 3, 6, 4] }, 7],
    [{ prices: [1, 2, 3, 4, 5] }, 4],
    [{ prices: [7, 6, 4, 3, 1] }, 0],
  ]),
  P('jump-game', 'Jump Game', 'Medium', 'Return true if you can reach the last index when nums[i] is the maximum jump length from i.', [A.ints('nums')], 'bool', { nums: [2, 3, 1, 1, 4] }, true, [
    [{ nums: [2, 3, 1, 1, 4] }, true],
    [{ nums: [3, 2, 1, 0, 4] }, false],
    [{ nums: [0] }, true],
  ]),
  P('partition-equal-subset-sum', 'Partition Equal Subset Sum', 'Medium', 'Return true if nums can be split into two subsets with equal sum.', [A.ints('nums')], 'bool', { nums: [1, 5, 11, 5] }, true, [
    [{ nums: [1, 5, 11, 5] }, true],
    [{ nums: [1, 2, 3, 5] }, false],
    [{ nums: [2, 2, 1, 1] }, true],
  ]),
  P('edit-distance', 'Edit Distance', 'Hard', 'Return the minimum number of insertions, deletions, and replacements needed to convert word1 into word2.', [A.string('word1'), A.string('word2')], 'int', { word1: 'horse', word2: 'ros' }, 3, [
    [{ word1: 'horse', word2: 'ros' }, 3],
    [{ word1: 'intention', word2: 'execution' }, 5],
    [{ word1: '', word2: 'abc' }, 3],
  ]),
  P('sort-an-array', 'Sort an Array', 'Medium', 'Return nums sorted in ascending order.', [A.ints('nums')], 'intArray', { nums: [5, 2, 3, 1] }, [1, 2, 3, 5], [
    [{ nums: [5, 2, 3, 1] }, [1, 2, 3, 5]],
    [{ nums: [5, 1, 1, 2, 0, 0] }, [0, 0, 1, 1, 2, 5]],
    [{ nums: [-1, 2, -8, 0] }, [-8, -1, 0, 2]],
  ]),
  P('largest-rectangle-in-histogram', 'Largest Rectangle in Histogram', 'Hard', 'Given bar heights, return the largest rectangle area in the histogram.', [A.ints('heights')], 'int', { heights: [2, 1, 5, 6, 2, 3] }, 10, [
    [{ heights: [2, 1, 5, 6, 2, 3] }, 10],
    [{ heights: [2, 4] }, 4],
    [{ heights: [1, 1, 1, 1] }, 4],
  ]),
  P('daily-temperatures', 'Daily Temperatures', 'Medium', 'For each day, return how many days until a warmer temperature, or 0 if none exists.', [A.ints('temperatures')], 'intArray', { temperatures: [73, 74, 75, 71, 69, 72, 76, 73] }, [1, 1, 4, 2, 1, 1, 0, 0], [
    [{ temperatures: [73, 74, 75, 71, 69, 72, 76, 73] }, [1, 1, 4, 2, 1, 1, 0, 0]],
    [{ temperatures: [30, 40, 50, 60] }, [1, 1, 1, 0]],
    [{ temperatures: [30, 60, 90] }, [1, 1, 0]],
  ]),
  P('next-greater-element-i', 'Next Greater Element I', 'Easy', 'For each value in nums1, return its next greater value to the right in nums2, or -1 if none exists.', [A.ints('nums1'), A.ints('nums2')], 'intArray', { nums1: [4, 1, 2], nums2: [1, 3, 4, 2] }, [-1, 3, -1], [
    [{ nums1: [4, 1, 2], nums2: [1, 3, 4, 2] }, [-1, 3, -1]],
    [{ nums1: [2, 4], nums2: [1, 2, 3, 4] }, [3, -1]],
  ]),
  P('online-stock-span', 'Online Stock Span', 'Medium', 'Given daily prices, return the stock span for each day.', [A.ints('prices')], 'intArray', { prices: [100, 80, 60, 70, 60, 75, 85] }, [1, 1, 1, 2, 1, 4, 6], [
    [{ prices: [100, 80, 60, 70, 60, 75, 85] }, [1, 1, 1, 2, 1, 4, 6]],
    [{ prices: [31, 41, 48, 59] }, [1, 2, 3, 4]],
  ]),
  P('sum-of-subarray-minimums', 'Sum of Subarray Minimums', 'Medium', 'Return the sum of the minimum value of every contiguous subarray.', [A.ints('arr')], 'int', { arr: [3, 1, 2, 4] }, 17, [
    [{ arr: [3, 1, 2, 4] }, 17],
    [{ arr: [11, 81, 94, 43, 3] }, 444],
    [{ arr: [1, 1, 1] }, 6],
  ]),
  P('subsets', 'Subsets', 'Medium', 'Return all subsets of nums, sorted lexicographically.', [A.ints('nums')], 'intMatrix', { nums: [1, 2, 3] }, [[], [1], [1, 2], [1, 2, 3], [1, 3], [2], [2, 3], [3]], [
    [{ nums: [1, 2] }, [[], [1], [1, 2], [2]]],
    [{ nums: [0] }, [[], [0]]],
  ]),
  P('subsets-ii', 'Subsets II', 'Medium', 'Return all unique subsets of nums that may contain duplicates, sorted lexicographically.', [A.ints('nums')], 'intMatrix', { nums: [1, 2, 2] }, [[], [1], [1, 2], [1, 2, 2], [2], [2, 2]], [
    [{ nums: [1, 2, 2] }, [[], [1], [1, 2], [1, 2, 2], [2], [2, 2]]],
    [{ nums: [0] }, [[], [0]]],
  ]),
  P('permutations', 'Permutations', 'Medium', 'Return all permutations of nums sorted lexicographically.', [A.ints('nums')], 'intMatrix', { nums: [1, 2, 3] }, [[1, 2, 3], [1, 3, 2], [2, 1, 3], [2, 3, 1], [3, 1, 2], [3, 2, 1]], [
    [{ nums: [1, 2] }, [[1, 2], [2, 1]]],
    [{ nums: [0, 1] }, [[0, 1], [1, 0]]],
  ]),
  P('combination-sum', 'Combination Sum', 'Medium', 'Return unique combinations where candidates can be reused and sum to target. Sort inner and outer lists.', [A.ints('candidates'), A.int('target')], 'intMatrix', { candidates: [2, 3, 6, 7], target: 7 }, [[2, 2, 3], [7]], [
    [{ candidates: [2, 3, 6, 7], target: 7 }, [[2, 2, 3], [7]]],
    [{ candidates: [2, 3, 5], target: 8 }, [[2, 2, 2, 2], [2, 3, 3], [3, 5]]],
  ]),
  P('letter-combinations-of-a-phone-number', 'Letter Combinations of a Phone Number', 'Medium', 'Return all letter combinations for the given digit string using the phone keypad mapping.', [A.string('digits')], 'stringArray', { digits: '23' }, ['ad', 'ae', 'af', 'bd', 'be', 'bf', 'cd', 'ce', 'cf'], [
    [{ digits: '23' }, ['ad', 'ae', 'af', 'bd', 'be', 'bf', 'cd', 'ce', 'cf']],
    [{ digits: '' }, []],
    [{ digits: '2' }, ['a', 'b', 'c']],
  ]),
  P('generate-parentheses', 'Generate Parentheses', 'Medium', 'Generate all well-formed parentheses strings containing n pairs, sorted lexicographically.', [A.int('n')], 'stringArray', { n: 3 }, ['((()))', '(()())', '(())()', '()(())', '()()()'], [
    [{ n: 1 }, ['()']],
    [{ n: 3 }, ['((()))', '(()())', '(())()', '()(())', '()()()']],
  ]),
  P('palindrome-partitioning', 'Palindrome Partitioning', 'Medium', 'Return all palindrome partitions of s, with each partition joined by | and sorted lexicographically.', [A.string('s')], 'stringArray', { s: 'aab' }, ['a|a|b', 'aa|b'], [
    [{ s: 'aab' }, ['a|a|b', 'aa|b']],
    [{ s: 'a' }, ['a']],
  ]),
  P('n-queens', 'N-Queens', 'Hard', 'Return every valid n-queens board encoded as slash-joined rows, sorted lexicographically.', [A.int('n')], 'stringArray', { n: 4 }, ['.Q../...Q/Q.../..Q.', '..Q./Q.../...Q/.Q..'], [
    [{ n: 1 }, ['Q']],
    [{ n: 4 }, ['.Q../...Q/Q.../..Q.', '..Q./Q.../...Q/.Q..']],
  ]),
  P('valid-parenthesis-string', 'Valid Parenthesis String', 'Medium', 'Return true if * can be treated as (, ), or empty to make s a valid parentheses string.', [A.string('s')], 'bool', { s: '(*)' }, true, [
    [{ s: '()' }, true],
    [{ s: '(*)' }, true],
    [{ s: '(*))' }, true],
    [{ s: '(((*)' }, false],
  ]),
  P('check-if-a-parentheses-string-can-be-valid', 'Check if a Parentheses String Can Be Valid', 'Medium', 'Given s and locked, return true if unlocked positions can be changed to make s valid.', [A.string('s'), A.string('locked')], 'bool', { s: '))()))', locked: '010100' }, true, [
    [{ s: '))()))', locked: '010100' }, true],
    [{ s: '()()', locked: '0000' }, true],
    [{ s: ')', locked: '0' }, false],
  ]),
  P('minimum-remove-to-make-valid-parentheses', 'Minimum Remove to Make Valid Parentheses', 'Medium', 'Remove the fewest parentheses to make s valid and return the resulting string.', [A.string('s')], 'string', { s: 'lee(t(c)o)de)' }, 'lee(t(c)o)de', [
    [{ s: 'lee(t(c)o)de)' }, 'lee(t(c)o)de'],
    [{ s: 'a)b(c)d' }, 'ab(c)d'],
    [{ s: '))((' }, ''],
  ]),
  P('minimum-number-of-swaps-to-make-the-string-balanced', 'Minimum Number of Swaps to Make the String Balanced', 'Medium', 'Given a bracket string with equal [ and ], return the minimum swaps needed to make it balanced.', [A.string('s')], 'int', { s: '][][' }, 1, [
    [{ s: '][][' }, 1],
    [{ s: ']]][[[' }, 2],
    [{ s: '[]' }, 0],
  ]),
  P('different-ways-to-add-parentheses', 'Different Ways to Add Parentheses', 'Medium', 'Return all possible results from computing the arithmetic expression with different parenthesization, sorted ascending.', [A.string('expression')], 'intArray', { expression: '2-1-1' }, [0, 2], [
    [{ expression: '2-1-1' }, [0, 2]],
    [{ expression: '2*3-4*5' }, [-34, -14, -10, -10, 10]],
  ]),
  P('basic-calculator', 'Basic Calculator', 'Hard', 'Evaluate an expression containing non-negative integers, +, -, parentheses, and spaces.', [A.string('s')], 'int', { s: '1 + 1' }, 2, [
    [{ s: '1 + 1' }, 2],
    [{ s: ' 2-1 + 2 ' }, 3],
    [{ s: '(1+(4+5+2)-3)+(6+8)' }, 23],
  ]),
  P('132-pattern', '132 Pattern', 'Medium', 'Return true if nums contains indices i < j < k such that nums[i] < nums[k] < nums[j].', [A.ints('nums')], 'bool', { nums: [3, 1, 4, 2] }, true, [
    [{ nums: [1, 2, 3, 4] }, false],
    [{ nums: [3, 1, 4, 2] }, true],
    [{ nums: [-1, 3, 2, 0] }, true],
  ]),
  P('number-of-atoms', 'Number of Atoms', 'Hard', 'Given a chemical formula, return the canonical atom count string with atom names sorted alphabetically.', [A.string('formula')], 'string', { formula: 'Mg(OH)2' }, 'H2MgO2', [
    [{ formula: 'H2O' }, 'H2O'],
    [{ formula: 'Mg(OH)2' }, 'H2MgO2'],
    [{ formula: 'K4(ON(SO3)2)2' }, 'K4N2O14S4'],
  ]),
  P('number-of-islands', 'Number of Islands', 'Medium', 'Given a 0/1 grid, return the number of connected groups of 1s using four-directional adjacency.', [A.matrix('grid')], 'int', { grid: [[1, 1, 0], [0, 1, 0], [1, 0, 1]] }, 3, [
    [{ grid: [[1, 1, 1], [0, 1, 0], [1, 0, 1]] }, 3],
    [{ grid: [[1, 1, 0, 0], [1, 0, 0, 1], [0, 0, 1, 1]] }, 2],
    [{ grid: [[0, 0], [0, 0]] }, 0],
  ]),
  P('max-area-of-island', 'Max Area of Island', 'Medium', 'Given a 0/1 grid, return the largest connected island area using four-directional adjacency.', [A.matrix('grid')], 'int', { grid: [[0, 1, 0], [1, 1, 0], [0, 0, 1]] }, 3, [
    [{ grid: [[0, 1, 0], [1, 1, 0], [0, 0, 1]] }, 3],
    [{ grid: [[0, 0], [0, 0]] }, 0],
    [{ grid: [[1, 1], [1, 1]] }, 4],
  ]),
  P('count-sub-islands', 'Count Sub Islands', 'Medium', 'Return the number of islands in grid2 whose land cells are all also land in grid1.', [A.matrix('grid1'), A.matrix('grid2')], 'int', { grid1: [[1, 1, 1], [0, 1, 0]], grid2: [[1, 1, 0], [0, 1, 1]] }, 0, [
    [{ grid1: [[1, 1, 1], [0, 1, 0]], grid2: [[1, 1, 0], [0, 1, 1]] }, 0],
    [{ grid1: [[1, 1], [1, 1]], grid2: [[1, 0], [0, 1]] }, 2],
  ]),
  P('find-if-path-exists-in-graph', 'Find if Path Exists in Graph', 'Easy', 'Given n, undirected edges, source, and destination, return true if a path exists.', [A.int('n'), A.matrix('edges'), A.int('source'), A.int('destination')], 'bool', { n: 3, edges: [[0, 1], [1, 2], [2, 0]], source: 0, destination: 2 }, true, [
    [{ n: 3, edges: [[0, 1], [1, 2], [2, 0]], source: 0, destination: 2 }, true],
    [{ n: 6, edges: [[0, 1], [0, 2], [3, 5], [5, 4], [4, 3]], source: 0, destination: 5 }, false],
  ]),
  P('is-graph-bipartite', 'Is Graph Bipartite?', 'Medium', 'Given an adjacency list encoded as rows of neighbors, return true if the graph is bipartite.', [A.matrix('graph')], 'bool', { graph: [[1, 3], [0, 2], [1, 3], [0, 2]] }, true, [
    [{ graph: [[1, 2, 3], [0, 2], [0, 1, 3], [0, 2]] }, false],
    [{ graph: [[1, 3], [0, 2], [1, 3], [0, 2]] }, true],
  ]),
  P('course-schedule-ii', 'Course Schedule II', 'Medium', 'Return one valid course ordering for numCourses and prerequisites, or [] if impossible. Use the lexicographically smallest valid order.', [A.int('numCourses'), A.matrix('prerequisites')], 'intArray', { numCourses: 4, prerequisites: [[1, 0], [2, 0], [3, 1], [3, 2]] }, [0, 1, 2, 3], [
    [{ numCourses: 2, prerequisites: [[1, 0]] }, [0, 1]],
    [{ numCourses: 4, prerequisites: [[1, 0], [2, 0], [3, 1], [3, 2]] }, [0, 1, 2, 3]],
    [{ numCourses: 2, prerequisites: [[0, 1], [1, 0]] }, []],
  ]),
  P('redundant-connection', 'Redundant Connection', 'Medium', 'Given edges of an undirected graph that started as a tree plus one extra edge, return the edge that creates a cycle.', [A.matrix('edges')], 'intArray', { edges: [[1, 2], [1, 3], [2, 3]] }, [2, 3], [
    [{ edges: [[1, 2], [1, 3], [2, 3]] }, [2, 3]],
    [{ edges: [[1, 2], [2, 3], [3, 4], [1, 4], [1, 5]] }, [1, 4]],
  ]),
  P('evaluate-division', 'Evaluate Division', 'Medium', 'Given equations encoded as variable pairs, values, and queries, return each query result.', [A.matrix('equations'), A.strings('names'), A.ints('values'), A.matrix('queries')], 'doubleArray', { equations: [[0, 1], [1, 2]], names: ['a', 'b', 'c'], values: [2, 3], queries: [[0, 2], [1, 0], [0, 3]] }, [6, 0.5, -1], [
    [{ equations: [[0, 1], [1, 2]], names: ['a', 'b', 'c'], values: [2, 3], queries: [[0, 2], [1, 0], [0, 3]] }, [6, 0.5, -1]],
  ]),
  P('path-with-maximum-probability', 'Path with Maximum Probability', 'Medium', 'Given weighted undirected edges and start/end nodes, return the maximum success probability.', [A.int('n'), A.matrix('edges'), A.ints('probabilityPercent'), A.int('start'), A.int('end')], 'double', { n: 3, edges: [[0, 1], [1, 2], [0, 2]], probabilityPercent: [50, 50, 20], start: 0, end: 2 }, 0.25, [
    [{ n: 3, edges: [[0, 1], [1, 2], [0, 2]], probabilityPercent: [50, 50, 20], start: 0, end: 2 }, 0.25],
    [{ n: 3, edges: [[0, 1]], probabilityPercent: [50], start: 0, end: 2 }, 0],
  ]),
  P('path-with-minimum-effort', 'Path With Minimum Effort', 'Medium', 'Given heights, return the minimum possible maximum absolute difference along a path from top-left to bottom-right.', [A.matrix('heights')], 'int', { heights: [[1, 2, 2], [3, 8, 2], [5, 3, 5]] }, 2, [
    [{ heights: [[1, 2, 2], [3, 8, 2], [5, 3, 5]] }, 2],
    [{ heights: [[1, 2, 3], [3, 8, 4], [5, 3, 5]] }, 1],
  ]),
  P('clone-graph', 'Clone Graph', 'Medium', 'Given an undirected graph adjacency list, return a deep-cloned adjacency list with the same structure.', [A.matrix('graph')], 'intMatrix', { graph: [[2, 4], [1, 3], [2, 4], [1, 3]] }, [[2, 4], [1, 3], [2, 4], [1, 3]], [
    [{ graph: [[2, 4], [1, 3], [2, 4], [1, 3]] }, [[2, 4], [1, 3], [2, 4], [1, 3]]],
    [{ graph: [[]] }, [[]]],
  ]),
  P('reverse-linked-list', 'Reverse Linked List', 'Easy', 'Given a linked list encoded as an array, return the values in reversed linked-list order.', [A.ints('head')], 'intArray', { head: [1, 2, 3, 4, 5] }, [5, 4, 3, 2, 1], [
    [{ head: [1, 2, 3, 4, 5] }, [5, 4, 3, 2, 1]],
    [{ head: [1, 2] }, [2, 1]],
    [{ head: [] }, []],
  ]),
  P('middle-of-the-linked-list', 'Middle of the Linked List', 'Easy', 'Given a linked list encoded as an array, return the values from the middle node to the end.', [A.ints('head')], 'intArray', { head: [1, 2, 3, 4, 5] }, [3, 4, 5], [
    [{ head: [1, 2, 3, 4, 5] }, [3, 4, 5]],
    [{ head: [1, 2, 3, 4, 5, 6] }, [4, 5, 6]],
  ]),
  P('linked-list-cycle', 'Linked List Cycle', 'Easy', 'Given values and pos where the tail points back, return true if the encoded linked list has a cycle.', [A.ints('values'), A.int('pos')], 'bool', { values: [3, 2, 0, -4], pos: 1 }, true, [
    [{ values: [3, 2, 0, -4], pos: 1 }, true],
    [{ values: [1, 2], pos: 0 }, true],
    [{ values: [1], pos: -1 }, false],
  ]),
  P('copy-list-with-random-pointer', 'Copy List with Random Pointer', 'Medium', 'Given nodes encoded as [value, randomIndex], return a deep-copied encoding with the same values and random links.', [A.matrix('nodes')], 'intMatrix', { nodes: [[7, -1], [13, 0], [11, 4], [10, 2], [1, 0]] }, [[7, -1], [13, 0], [11, 4], [10, 2], [1, 0]], [
    [{ nodes: [[7, -1], [13, 0], [11, 4], [10, 2], [1, 0]] }, [[7, -1], [13, 0], [11, 4], [10, 2], [1, 0]]],
    [{ nodes: [] }, []],
  ]),
  P('binary-tree-inorder-traversal', 'Binary Tree Inorder Traversal', 'Easy', 'Given a binary tree encoded as a level-order array with -100000 as null, return its inorder traversal.', [A.ints('root')], 'intArray', { root: [1, -100000, 2, 3] }, [1, 3, 2], [
    [{ root: [1, -100000, 2, 3] }, [1, 3, 2]],
    [{ root: [] }, []],
    [{ root: [1] }, [1]],
  ]),
  P('invert-binary-tree', 'Invert Binary Tree', 'Easy', 'Given a binary tree encoded as level-order with -100000 as null, return the inverted tree in level-order using the same encoding.', [A.ints('root')], 'intArray', { root: [4, 2, 7, 1, 3, 6, 9] }, [4, 7, 2, 9, 6, 3, 1], [
    [{ root: [4, 2, 7, 1, 3, 6, 9] }, [4, 7, 2, 9, 6, 3, 1]],
    [{ root: [2, 1, 3] }, [2, 3, 1]],
  ]),
  P('same-tree', 'Same Tree', 'Easy', 'Given two binary trees encoded as level-order arrays with -100000 as null, return true if they are structurally identical with equal values.', [A.ints('p'), A.ints('q')], 'bool', { p: [1, 2, 3], q: [1, 2, 3] }, true, [
    [{ p: [1, 2, 3], q: [1, 2, 3] }, true],
    [{ p: [1, 2], q: [1, -100000, 2] }, false],
    [{ p: [1, 2, 1], q: [1, 1, 2] }, false],
  ]),
  P('symmetric-tree', 'Symmetric Tree', 'Easy', 'Given a binary tree encoded as level-order with -100000 as null, return true if it is symmetric.', [A.ints('root')], 'bool', { root: [1, 2, 2, 3, 4, 4, 3] }, true, [
    [{ root: [1, 2, 2, 3, 4, 4, 3] }, true],
    [{ root: [1, 2, 2, -100000, 3, -100000, 3] }, false],
  ]),
  P('maximum-depth-of-binary-tree', 'Maximum Depth of Binary Tree', 'Easy', 'Given a binary tree encoded as level-order with -100000 as null, return its maximum depth.', [A.ints('root')], 'int', { root: [3, 9, 20, -100000, -100000, 15, 7] }, 3, [
    [{ root: [3, 9, 20, -100000, -100000, 15, 7] }, 3],
    [{ root: [1, -100000, 2] }, 2],
    [{ root: [] }, 0],
  ]),
  P('minimum-depth-of-binary-tree', 'Minimum Depth of Binary Tree', 'Easy', 'Given a binary tree encoded as level-order with -100000 as null, return its minimum root-to-leaf depth.', [A.ints('root')], 'int', { root: [3, 9, 20, -100000, -100000, 15, 7] }, 2, [
    [{ root: [3, 9, 20, -100000, -100000, 15, 7] }, 2],
    [{ root: [2, -100000, 3, -100000, 4] }, 3],
  ]),
  P('path-sum', 'Path Sum', 'Easy', 'Given a binary tree encoded as level-order with -100000 as null and targetSum, return true if a root-to-leaf path sums to targetSum.', [A.ints('root'), A.int('targetSum')], 'bool', { root: [5, 4, 8, 11, -100000, 13, 4, 7, 2, -100000, -100000, -100000, 1], targetSum: 22 }, true, [
    [{ root: [5, 4, 8, 11, -100000, 13, 4, 7, 2, -100000, -100000, -100000, 1], targetSum: 22 }, true],
    [{ root: [1, 2, 3], targetSum: 5 }, false],
  ]),
  P('validate-binary-search-tree', 'Validate Binary Search Tree', 'Medium', 'Given a binary tree encoded as level-order with -100000 as null, return true if it is a valid BST.', [A.ints('root')], 'bool', { root: [2, 1, 3] }, true, [
    [{ root: [2, 1, 3] }, true],
    [{ root: [5, 1, 4, -100000, -100000, 3, 6] }, false],
  ]),
  P('binary-tree-level-order-traversal', 'Binary Tree Level Order Traversal', 'Medium', 'Given a binary tree encoded as level-order with -100000 as null, return level order traversal as a list of levels.', [A.ints('root')], 'intMatrix', { root: [3, 9, 20, -100000, -100000, 15, 7] }, [[3], [9, 20], [15, 7]], [
    [{ root: [3, 9, 20, -100000, -100000, 15, 7] }, [[3], [9, 20], [15, 7]]],
    [{ root: [1] }, [[1]]],
    [{ root: [] }, []],
  ]),
  P('lowest-common-ancestor-of-a-binary-search-tree', 'Lowest Common Ancestor of a Binary Search Tree', 'Medium', 'Given a BST encoded as level-order and two values p and q, return the lowest common ancestor value.', [A.ints('root'), A.int('p'), A.int('q')], 'int', { root: [6, 2, 8, 0, 4, 7, 9, -100000, -100000, 3, 5], p: 2, q: 8 }, 6, [
    [{ root: [6, 2, 8, 0, 4, 7, 9, -100000, -100000, 3, 5], p: 2, q: 8 }, 6],
    [{ root: [6, 2, 8, 0, 4, 7, 9, -100000, -100000, 3, 5], p: 2, q: 4 }, 2],
  ]),
  P('binary-tree-maximum-path-sum', 'Binary Tree Maximum Path Sum', 'Hard', 'Given a binary tree encoded as level-order with -100000 as null, return the maximum path sum.', [A.ints('root')], 'int', { root: [1, 2, 3] }, 6, [
    [{ root: [1, 2, 3] }, 6],
    [{ root: [-10, 9, 20, -100000, -100000, 15, 7] }, 42],
  ]),
  P('serialize-and-deserialize-binary-tree', 'Serialize and Deserialize Binary Tree', 'Hard', 'Given a binary tree encoded as level-order with -100000 as null, return the canonical serialized level-order encoding after deserialize/serialize.', [A.ints('root')], 'intArray', { root: [1, 2, 3, -100000, -100000, 4, 5] }, [1, 2, 3, -100000, -100000, 4, 5], [
    [{ root: [1, 2, 3, -100000, -100000, 4, 5] }, [1, 2, 3, -100000, -100000, 4, 5]],
    [{ root: [] }, []],
  ]),
  P('merge-intervals', 'Merge Intervals', 'Medium', 'Given intervals, return overlapping intervals merged and sorted by start.', [A.matrix('intervals')], 'intMatrix', { intervals: [[1, 3], [2, 6], [8, 10], [15, 18]] }, [[1, 6], [8, 10], [15, 18]], [
    [{ intervals: [[1, 3], [2, 6], [8, 10], [15, 18]] }, [[1, 6], [8, 10], [15, 18]]],
    [{ intervals: [[1, 4], [4, 5]] }, [[1, 5]]],
  ]),
  P('insert-interval', 'Insert Interval', 'Medium', 'Insert newInterval into sorted non-overlapping intervals and return the merged result.', [A.matrix('intervals'), A.ints('newInterval')], 'intMatrix', { intervals: [[1, 3], [6, 9]], newInterval: [2, 5] }, [[1, 5], [6, 9]], [
    [{ intervals: [[1, 3], [6, 9]], newInterval: [2, 5] }, [[1, 5], [6, 9]]],
    [{ intervals: [[1, 2], [3, 5], [6, 7], [8, 10], [12, 16]], newInterval: [4, 8] }, [[1, 2], [3, 10], [12, 16]]],
  ]),
  P('interval-list-intersections', 'Interval List Intersections', 'Medium', 'Return all intersections between two sorted lists of disjoint intervals.', [A.matrix('firstList'), A.matrix('secondList')], 'intMatrix', { firstList: [[0, 2], [5, 10], [13, 23], [24, 25]], secondList: [[1, 5], [8, 12], [15, 24], [25, 26]] }, [[1, 2], [5, 5], [8, 10], [15, 23], [24, 24], [25, 25]], [
    [{ firstList: [[0, 2], [5, 10], [13, 23], [24, 25]], secondList: [[1, 5], [8, 12], [15, 24], [25, 26]] }, [[1, 2], [5, 5], [8, 10], [15, 23], [24, 24], [25, 25]]],
    [{ firstList: [], secondList: [[1, 3]] }, []],
  ]),
  P('meeting-rooms-ii', 'Meeting Rooms II', 'Medium', 'Given meeting intervals, return the minimum number of rooms required.', [A.matrix('intervals')], 'int', { intervals: [[0, 30], [5, 10], [15, 20]] }, 2, [
    [{ intervals: [[0, 30], [5, 10], [15, 20]] }, 2],
    [{ intervals: [[7, 10], [2, 4]] }, 1],
  ]),
  P('random-pick-with-weight', 'Random Pick with Weight', 'Medium', 'Given weights and random target values in [1,totalWeight], return the picked index for each target using weighted prefix ranges.', [A.ints('w'), A.ints('targets')], 'intArray', { w: [1, 3], targets: [1, 2, 4] }, [0, 1, 1], [
    [{ w: [1, 3], targets: [1, 2, 4] }, [0, 1, 1]],
    [{ w: [2, 5, 3], targets: [1, 3, 8, 10] }, [0, 1, 2, 2]],
  ]),
  P('range-sum-query-2d-immutable', 'Range Sum Query 2D - Immutable', 'Medium', 'Given matrix and [r1,c1,r2,c2] queries, return each submatrix sum.', [A.matrix('matrix'), A.matrix('queries')], 'intArray', { matrix: [[3, 0, 1, 4, 2], [5, 6, 3, 2, 1], [1, 2, 0, 1, 5], [4, 1, 0, 1, 7], [1, 0, 3, 0, 5]], queries: [[2, 1, 4, 3], [1, 1, 2, 2], [1, 2, 2, 4]] }, [8, 11, 12], [
    [{ matrix: [[3, 0, 1, 4, 2], [5, 6, 3, 2, 1], [1, 2, 0, 1, 5], [4, 1, 0, 1, 7], [1, 0, 3, 0, 5]], queries: [[2, 1, 4, 3], [1, 1, 2, 2], [1, 2, 2, 4]] }, [8, 11, 12]],
  ]),
  P('range-sum-query-mutable', 'Range Sum Query Mutable', 'Medium', 'Apply updates [index,value] to nums and answer range-sum queries [left,right]. Return the query results.', [A.ints('nums'), A.matrix('updates'), A.matrix('queries')], 'intArray', { nums: [1, 3, 5], updates: [[1, 2]], queries: [[0, 2], [0, 2]] }, [9, 8], [
    [{ nums: [1, 3, 5], updates: [[1, 2]], queries: [[0, 2], [0, 2]] }, [9, 8]],
  ]),
  P('count-of-smaller-numbers-after-self', 'Count of Smaller Numbers After Self', 'Hard', 'For each nums[i], return the count of smaller numbers to its right.', [A.ints('nums')], 'intArray', { nums: [5, 2, 6, 1] }, [2, 1, 1, 0], [
    [{ nums: [5, 2, 6, 1] }, [2, 1, 1, 0]],
    [{ nums: [-1] }, [0]],
    [{ nums: [-1, -1] }, [0, 0]],
  ]),
  P('min-stack', 'Min Stack', 'Medium', 'Simulate a min stack. Operations are push, pop, top, and getMin. Return outputs for top and getMin.', [A.strings('operations'), A.ints('values')], 'intArray', { operations: ['push', 'push', 'push', 'getMin', 'pop', 'top', 'getMin'], values: [-2, 0, -3, 0, 0, 0, 0] }, [-3, 0, -2], [
    [{ operations: ['push', 'push', 'push', 'getMin', 'pop', 'top', 'getMin'], values: [-2, 0, -3, 0, 0, 0, 0] }, [-3, 0, -2]],
  ]),
  P('implement-stack-using-queues', 'Implement Stack using Queues', 'Easy', 'Simulate a stack. Operations are push, pop, top, and empty. Return outputs for pop, top, and empty using 1 for true and 0 for false.', [A.strings('operations'), A.ints('values')], 'intArray', { operations: ['push', 'push', 'top', 'pop', 'empty'], values: [1, 2, 0, 0, 0] }, [2, 2, 0], [
    [{ operations: ['push', 'push', 'top', 'pop', 'empty'], values: [1, 2, 0, 0, 0] }, [2, 2, 0]],
  ]),
  P('insert-delete-getrandom-o', 'Insert Delete GetRandom O(1)', 'Medium', 'Simulate insert, remove, and getRandom with deterministic random indices. Return 1/0 for insert/remove and selected values for getRandom.', [A.strings('operations'), A.ints('values'), A.ints('randomIndices')], 'intArray', { operations: ['insert', 'remove', 'insert', 'getRandom'], values: [1, 2, 2, 0], randomIndices: [0] }, [1, 0, 1, 1], [
    [{ operations: ['insert', 'remove', 'insert', 'getRandom'], values: [1, 2, 2, 0], randomIndices: [0] }, [1, 0, 1, 1]],
  ]),
  P('lru-cache', 'LRU Cache', 'Medium', 'Simulate an LRU cache. Operations are put and get. Return outputs for get operations.', [A.int('capacity'), A.strings('operations'), A.matrix('values')], 'intArray', { capacity: 2, operations: ['put', 'put', 'get', 'put', 'get', 'put', 'get', 'get', 'get'], values: [[1, 1], [2, 2], [1], [3, 3], [2], [4, 4], [1], [3], [4]] }, [1, -1, -1, 3, 4], [
    [{ capacity: 2, operations: ['put', 'put', 'get', 'put', 'get', 'put', 'get', 'get', 'get'], values: [[1, 1], [2, 2], [1], [3, 3], [2], [4, 4], [1], [3], [4]] }, [1, -1, -1, 3, 4]],
  ]),
  P('lfu-cache', 'LFU Cache', 'Hard', 'Simulate an LFU cache. Evict the least frequently used key, breaking ties by least recent use. Return outputs for get operations.', [A.int('capacity'), A.strings('operations'), A.matrix('values')], 'intArray', { capacity: 2, operations: ['put', 'put', 'get', 'put', 'get', 'get', 'put', 'get', 'get', 'get'], values: [[1, 1], [2, 2], [1], [3, 3], [2], [3], [4, 4], [1], [3], [4]] }, [1, -1, 3, -1, 3, 4], [
    [{ capacity: 2, operations: ['put', 'put', 'get', 'put', 'get', 'get', 'put', 'get', 'get', 'get'], values: [[1, 1], [2, 2], [1], [3, 3], [2], [3], [4, 4], [1], [3], [4]] }, [1, -1, 3, -1, 3, 4]],
  ]),
  P('implement-trie', 'Implement Trie (Prefix Tree)', 'Medium', 'Simulate a trie. Operations are insert, search, and startsWith. Return booleans for search and startsWith.', [A.strings('operations'), A.strings('words')], 'boolArray', { operations: ['insert', 'search', 'search', 'startsWith', 'insert', 'search'], words: ['apple', 'apple', 'app', 'app', 'app', 'app'] }, [true, false, true, true], [
    [{ operations: ['insert', 'search', 'search', 'startsWith', 'insert', 'search'], words: ['apple', 'apple', 'app', 'app', 'app', 'app'] }, [true, false, true, true]],
  ], ['implement-trie-prefix-tree']),
  P('binary-search-tree-iterator', 'Binary Search Tree Iterator', 'Medium', 'Given a BST encoded as level-order with -100000 as null, return all next() values from a BST iterator.', [A.ints('root')], 'intArray', { root: [7, 3, 15, -100000, -100000, 9, 20] }, [3, 7, 9, 15, 20], [
    [{ root: [7, 3, 15, -100000, -100000, 9, 20] }, [3, 7, 9, 15, 20]],
  ]),
  P('find-median-from-data-stream', 'Find Median from Data Stream', 'Hard', 'Given a stream of numbers, return the median after each insertion.', [A.ints('nums')], 'doubleArray', { nums: [1, 2, 3] }, [1, 1.5, 2], [
    [{ nums: [1, 2, 3] }, [1, 1.5, 2]],
    [{ nums: [5, 15, 1, 3] }, [5, 10, 5, 4]],
  ]),
  P('maximum-profit-in-job-scheduling', 'Maximum Profit in Job Scheduling', 'Hard', 'Given startTime, endTime, and profit arrays, return the maximum profit from non-overlapping jobs.', [A.ints('startTime'), A.ints('endTime'), A.ints('profit')], 'int', { startTime: [1, 2, 3, 3], endTime: [3, 4, 5, 6], profit: [50, 10, 40, 70] }, 120, [
    [{ startTime: [1, 2, 3, 3], endTime: [3, 4, 5, 6], profit: [50, 10, 40, 70] }, 120],
    [{ startTime: [1, 2, 3, 4, 6], endTime: [3, 5, 10, 6, 9], profit: [20, 20, 100, 70, 60] }, 150],
  ]),
  P('max-points-on-a-line', 'Max Points on a Line', 'Hard', 'Given points [x,y], return the maximum number of points on one straight line.', [A.matrix('points')], 'int', { points: [[1, 1], [2, 2], [3, 3]] }, 3, [
    [{ points: [[1, 1], [2, 2], [3, 3]] }, 3],
    [{ points: [[1, 1], [3, 2], [5, 3], [4, 1], [2, 3], [1, 4]] }, 4],
  ]),
  P('different-palindromic-substrings', 'Different Palindromic Substrings', 'Hard', 'Return the number of distinct palindromic substrings in s.', [A.string('s')], 'int', { s: 'bccb' }, 6, [
    [{ s: 'bccb' }, 6],
    [{ s: 'aaa' }, 3],
  ]),
  P('minimum-time-to-visit-all-houses', 'Minimum Time to Visit All Houses', 'Medium', 'Given house positions in order, return the total Manhattan distance needed to visit them all.', [A.matrix('points')], 'int', { points: [[1, 1], [3, 4], [-1, 0]] }, 7, [
    [{ points: [[1, 1], [3, 4], [-1, 0]] }, 7],
    [{ points: [[0, 0], [1, 1], [1, 2]] }, 3],
  ]),
  P('add-two-numbers', 'Add Two Numbers', 'Medium', 'Two non-empty linked lists store non-negative integers in reverse digit order. Return the sum as a linked list encoded in the same reverse digit order.', [A.ints('l1'), A.ints('l2')], 'intArray', { l1: [2, 4, 3], l2: [5, 6, 4] }, [7, 0, 8], [
    [{ l1: [2, 4, 3], l2: [5, 6, 4] }, [7, 0, 8]],
    [{ l1: [0], l2: [0] }, [0]],
    [{ l1: [9, 9, 9, 9, 9, 9, 9], l2: [9, 9, 9, 9] }, [8, 9, 9, 9, 0, 0, 0, 1]],
  ]),
  P('add-two-numbers-ii', 'Add Two Numbers II', 'Medium', 'Two non-empty linked lists store non-negative integers in forward digit order. Return the sum as a linked list encoded in forward digit order.', [A.ints('l1'), A.ints('l2')], 'intArray', { l1: [7, 2, 4, 3], l2: [5, 6, 4] }, [7, 8, 0, 7], [
    [{ l1: [7, 2, 4, 3], l2: [5, 6, 4] }, [7, 8, 0, 7]],
    [{ l1: [2, 4, 3], l2: [5, 6, 4] }, [8, 0, 7]],
    [{ l1: [9, 9, 9], l2: [1] }, [1, 0, 0, 0]],
  ]),
  P('delete-node-in-a-linked-list', 'Delete Node in a Linked List', 'Medium', 'Given a linked list encoded as an array and the value of the node to delete, return the list after deleting the first matching node. The value is guaranteed to be present and not the tail.', [A.ints('head'), A.int('value')], 'intArray', { head: [4, 5, 1, 9], value: 5 }, [4, 1, 9], [
    [{ head: [4, 5, 1, 9], value: 5 }, [4, 1, 9]],
    [{ head: [4, 5, 1, 9], value: 1 }, [4, 5, 9]],
  ]),
  P('merge-two-sorted-lists', 'Merge Two Sorted Lists', 'Easy', 'Given two sorted linked lists encoded as arrays, merge them into one sorted linked list and return its values.', [A.ints('list1'), A.ints('list2')], 'intArray', { list1: [1, 2, 4], list2: [1, 3, 4] }, [1, 1, 2, 3, 4, 4], [
    [{ list1: [1, 2, 4], list2: [1, 3, 4] }, [1, 1, 2, 3, 4, 4]],
    [{ list1: [], list2: [] }, []],
    [{ list1: [], list2: [0] }, [0]],
  ]),
  P('merge-k-sorted-lists', 'Merge k Sorted Lists', 'Hard', 'Given k sorted linked lists encoded as rows of values, merge all lists into one sorted linked list and return its values.', [A.matrix('lists')], 'intArray', { lists: [[1, 4, 5], [1, 3, 4], [2, 6]] }, [1, 1, 2, 3, 4, 4, 5, 6], [
    [{ lists: [[1, 4, 5], [1, 3, 4], [2, 6]] }, [1, 1, 2, 3, 4, 4, 5, 6]],
    [{ lists: [] }, []],
    [{ lists: [[]] }, []],
    [{ lists: [[-2, -1, 3], [], [0, 2]] }, [-2, -1, 0, 2, 3]],
  ]),
  P('remove-nth-node-from-end-of-list', 'Remove Nth Node From End of List', 'Medium', 'Given a linked list encoded as an array, remove the nth node from the end and return the remaining values.', [A.ints('head'), A.int('n')], 'intArray', { head: [1, 2, 3, 4, 5], n: 2 }, [1, 2, 3, 5], [
    [{ head: [1, 2, 3, 4, 5], n: 2 }, [1, 2, 3, 5]],
    [{ head: [1], n: 1 }, []],
    [{ head: [1, 2], n: 1 }, [1]],
    [{ head: [1, 2], n: 2 }, [2]],
  ]),
  P('reverse-linked-list-ii', 'Reverse Linked List II', 'Medium', 'Given a linked list encoded as an array, reverse the nodes from 1-indexed position left through right and return the resulting values.', [A.ints('head'), A.int('left'), A.int('right')], 'intArray', { head: [1, 2, 3, 4, 5], left: 2, right: 4 }, [1, 4, 3, 2, 5], [
    [{ head: [1, 2, 3, 4, 5], left: 2, right: 4 }, [1, 4, 3, 2, 5]],
    [{ head: [5], left: 1, right: 1 }, [5]],
    [{ head: [3, 5], left: 1, right: 2 }, [5, 3]],
  ]),
  P('rotate-list', 'Rotate List', 'Medium', 'Given a linked list encoded as an array, rotate it to the right by k positions and return the resulting values.', [A.ints('head'), A.int('k')], 'intArray', { head: [1, 2, 3, 4, 5], k: 2 }, [4, 5, 1, 2, 3], [
    [{ head: [1, 2, 3, 4, 5], k: 2 }, [4, 5, 1, 2, 3]],
    [{ head: [0, 1, 2], k: 4 }, [2, 0, 1]],
    [{ head: [], k: 3 }, []],
  ]),
  P('partition-list', 'Partition List', 'Medium', 'Given a linked list encoded as an array and x, keep relative order while moving nodes with values less than x before nodes with values at least x.', [A.ints('head'), A.int('x')], 'intArray', { head: [1, 4, 3, 2, 5, 2], x: 3 }, [1, 2, 2, 4, 3, 5], [
    [{ head: [1, 4, 3, 2, 5, 2], x: 3 }, [1, 2, 2, 4, 3, 5]],
    [{ head: [2, 1], x: 2 }, [1, 2]],
    [{ head: [], x: 0 }, []],
  ]),
  P('3sum-smaller', '3Sum Smaller', 'Medium', 'Return the number of index triplets whose values sum to less than target.', [A.ints('nums'), A.int('target')], 'int', { nums: [-2, 0, 1, 3], target: 2 }, 2, [
    [{ nums: [-2, 0, 1, 3], target: 2 }, 2],
    [{ nums: [], target: 0 }, 0],
    [{ nums: [3, 1, 0, -2], target: 4 }, 3],
  ]),
  P('best-time-to-buy-and-sell-stock-iii', 'Best Time to Buy and Sell Stock III', 'Hard', 'Return the maximum profit from at most two buy-sell transactions, holding at most one share at a time.', [A.ints('prices')], 'int', { prices: [3, 3, 5, 0, 0, 3, 1, 4] }, 6, [
    [{ prices: [3, 3, 5, 0, 0, 3, 1, 4] }, 6],
    [{ prices: [1, 2, 3, 4, 5] }, 4],
    [{ prices: [7, 6, 4, 3, 1] }, 0],
  ]),
  P('best-time-to-buy-and-sell-stock-iv', 'Best Time to Buy and Sell Stock IV', 'Hard', 'Return the maximum profit from at most k buy-sell transactions, holding at most one share at a time.', [A.int('k'), A.ints('prices')], 'int', { k: 2, prices: [2, 4, 1] }, 2, [
    [{ k: 2, prices: [2, 4, 1] }, 2],
    [{ k: 2, prices: [3, 2, 6, 5, 0, 3] }, 7],
    [{ k: 100, prices: [1, 2, 3, 4] }, 3],
  ]),
  P('best-time-to-buy-and-sell-stock-with-cooldown', 'Best Time to Buy and Sell Stock with Cooldown', 'Medium', 'Return the maximum stock-trading profit when selling forces a one-day cooldown before buying again.', [A.ints('prices')], 'int', { prices: [1, 2, 3, 0, 2] }, 3, [
    [{ prices: [1, 2, 3, 0, 2] }, 3],
    [{ prices: [1] }, 0],
    [{ prices: [2, 1, 4] }, 3],
  ]),
  P('best-time-to-buy-and-sell-stock-with-transaction-fee', 'Best Time to Buy and Sell Stock with Transaction Fee', 'Medium', 'Return the maximum profit from any number of transactions when each sale pays the given fee.', [A.ints('prices'), A.int('fee')], 'int', { prices: [1, 3, 2, 8, 4, 9], fee: 2 }, 8, [
    [{ prices: [1, 3, 2, 8, 4, 9], fee: 2 }, 8],
    [{ prices: [1, 3, 7, 5, 10, 3], fee: 3 }, 6],
  ]),
  P('binary-subarrays-with-sum', 'Binary Subarrays With Sum', 'Medium', 'Given a binary array, return the number of contiguous subarrays with sum equal to goal.', [A.ints('nums'), A.int('goal')], 'int', { nums: [1, 0, 1, 0, 1], goal: 2 }, 4, [
    [{ nums: [1, 0, 1, 0, 1], goal: 2 }, 4],
    [{ nums: [0, 0, 0, 0, 0], goal: 0 }, 15],
    [{ nums: [1, 1, 1], goal: 2 }, 2],
  ]),
  P('contains-duplicate-ii', 'Contains Duplicate II', 'Easy', 'Return true if two equal values appear at indices whose distance is at most k.', [A.ints('nums'), A.int('k')], 'bool', { nums: [1, 2, 3, 1], k: 3 }, true, [
    [{ nums: [1, 2, 3, 1], k: 3 }, true],
    [{ nums: [1, 0, 1, 1], k: 1 }, true],
    [{ nums: [1, 2, 3, 1, 2, 3], k: 2 }, false],
  ]),
  P('contains-duplicate-iii', 'Contains Duplicate III', 'Hard', 'Return true if two different indices are within indexDiff positions and their values differ by at most valueDiff.', [A.ints('nums'), A.int('indexDiff'), A.int('valueDiff')], 'bool', { nums: [1, 2, 3, 1], indexDiff: 3, valueDiff: 0 }, true, [
    [{ nums: [1, 2, 3, 1], indexDiff: 3, valueDiff: 0 }, true],
    [{ nums: [1, 5, 9, 1, 5, 9], indexDiff: 2, valueDiff: 3 }, false],
    [{ nums: [8, 7, 15, 1, 6, 1, 9, 15], indexDiff: 1, valueDiff: 3 }, true],
  ]),
  P('course-schedule', 'Course Schedule', 'Medium', 'Return true if all courses can be completed given prerequisite pairs [course, prerequisite].', [A.int('numCourses'), A.matrix('prerequisites')], 'bool', { numCourses: 2, prerequisites: [[1, 0]] }, true, [
    [{ numCourses: 2, prerequisites: [[1, 0]] }, true],
    [{ numCourses: 2, prerequisites: [[1, 0], [0, 1]] }, false],
    [{ numCourses: 4, prerequisites: [[1, 0], [2, 1], [3, 2]] }, true],
  ]),
  P('decode-string', 'Decode String', 'Medium', 'Decode a string where k[encoded] repeats the bracketed section k times, including nested sections.', [A.string('s')], 'string', { s: '3[a]2[bc]' }, 'aaabcbc', [
    [{ s: '3[a]2[bc]' }, 'aaabcbc'],
    [{ s: '3[a2[c]]' }, 'accaccacc'],
    [{ s: '2[abc]3[cd]ef' }, 'abcabccdcdcdef'],
  ]),
  P('decode-ways', 'Decode Ways', 'Medium', 'Return the number of ways to decode a digit string where A=1 through Z=26.', [A.string('s')], 'int', { s: '12' }, 2, [
    [{ s: '12' }, 2],
    [{ s: '226' }, 3],
    [{ s: '06' }, 0],
    [{ s: '11106' }, 2],
  ]),
  P('find-all-anagrams-in-a-string', 'Find All Anagrams in a String', 'Medium', 'Return all starting indices where an anagram of p appears in s.', [A.string('s'), A.string('p')], 'intArray', { s: 'cbaebabacd', p: 'abc' }, [0, 6], [
    [{ s: 'cbaebabacd', p: 'abc' }, [0, 6]],
    [{ s: 'abab', p: 'ab' }, [0, 1, 2]],
    [{ s: 'baa', p: 'aa' }, [1]],
  ]),
  P('house-robber-ii', 'House Robber II', 'Medium', 'Return the most money that can be robbed from circularly arranged houses without robbing adjacent houses.', [A.ints('nums')], 'int', { nums: [2, 3, 2] }, 3, [
    [{ nums: [2, 3, 2] }, 3],
    [{ nums: [1, 2, 3, 1] }, 4],
    [{ nums: [1, 2, 3] }, 3],
  ]),
  P('jump-game-ii', 'Jump Game II', 'Medium', 'Given max jump lengths, return the minimum number of jumps needed to reach the last index.', [A.ints('nums')], 'int', { nums: [2, 3, 1, 1, 4] }, 2, [
    [{ nums: [2, 3, 1, 1, 4] }, 2],
    [{ nums: [2, 3, 0, 1, 4] }, 2],
    [{ nums: [0] }, 0],
  ]),
  P('keys-and-rooms', 'Keys and Rooms', 'Medium', 'Rooms are encoded as rows of keys found inside each room. Starting from room 0, return true if every room can be visited.', [A.matrix('rooms')], 'bool', { rooms: [[1], [2], [3], []] }, true, [
    [{ rooms: [[1], [2], [3], []] }, true],
    [{ rooms: [[1, 3], [3, 0, 1], [2], [0]] }, false],
  ]),
  P('maximal-square', 'Maximal Square', 'Medium', 'Given a binary matrix, return the area of the largest square containing only 1s.', [A.matrix('matrix')], 'int', { matrix: [[1, 0, 1, 0, 0], [1, 0, 1, 1, 1], [1, 1, 1, 1, 1], [1, 0, 0, 1, 0]] }, 4, [
    [{ matrix: [[1, 0, 1, 0, 0], [1, 0, 1, 1, 1], [1, 1, 1, 1, 1], [1, 0, 0, 1, 0]] }, 4],
    [{ matrix: [[0, 1], [1, 0]] }, 1],
    [{ matrix: [[0]] }, 0],
  ]),
  P('maximal-rectangle', 'Maximal Rectangle', 'Hard', 'Given a binary matrix, return the area of the largest rectangle containing only 1s.', [A.matrix('matrix')], 'int', { matrix: [[1, 0, 1, 0, 0], [1, 0, 1, 1, 1], [1, 1, 1, 1, 1], [1, 0, 0, 1, 0]] }, 6, [
    [{ matrix: [[1, 0, 1, 0, 0], [1, 0, 1, 1, 1], [1, 1, 1, 1, 1], [1, 0, 0, 1, 0]] }, 6],
    [{ matrix: [[0]] }, 0],
    [{ matrix: [[1]] }, 1],
  ]),
  P('palindromic-substrings', 'Palindromic Substrings', 'Medium', 'Return the number of substrings of s that are palindromes.', [A.string('s')], 'int', { s: 'abc' }, 3, [
    [{ s: 'abc' }, 3],
    [{ s: 'aaa' }, 6],
    [{ s: 'racecar' }, 10],
  ]),
  P('alien-dictionary', 'Alien Dictionary', 'Hard', 'Given words sorted by an unknown alphabet, return the lexicographically smallest valid character order. Return an empty string if no valid order exists.', [A.strings('words')], 'string', { words: ['wrt', 'wrf', 'er', 'ett', 'rftt'] }, 'wertf', [
    [{ words: ['wrt', 'wrf', 'er', 'ett', 'rftt'] }, 'wertf'],
    [{ words: ['z', 'x'] }, 'zx'],
    [{ words: ['z', 'x', 'z'] }, ''],
    [{ words: ['abc', 'ab'] }, ''],
  ]),
  P('all-paths-from-source-to-target', 'All Paths From Source to Target', 'Medium', 'Given a DAG adjacency list, return every path from node 0 to node n-1 in lexicographic order.', [A.matrix('graph')], 'intMatrix', { graph: [[1, 2], [3], [3], []] }, [[0, 1, 3], [0, 2, 3]], [
    [{ graph: [[1, 2], [3], [3], []] }, [[0, 1, 3], [0, 2, 3]]],
    [{ graph: [[4, 3, 1], [3, 2, 4], [3], [4], []] }, [[0, 1, 2, 3, 4], [0, 1, 2, 4], [0, 1, 3, 4], [0, 1, 4], [0, 3, 4], [0, 4]]],
  ]),
  P('cheapest-flights-within-k-stops', 'Cheapest Flights Within K Stops', 'Medium', 'Given flights [from,to,price], return the cheapest price from src to dst using at most k stops, or -1 if unreachable.', [A.int('n'), A.matrix('flights'), A.int('src'), A.int('dst'), A.int('k')], 'int', { n: 4, flights: [[0, 1, 100], [1, 2, 100], [2, 0, 100], [1, 3, 600], [2, 3, 200]], src: 0, dst: 3, k: 1 }, 700, [
    [{ n: 4, flights: [[0, 1, 100], [1, 2, 100], [2, 0, 100], [1, 3, 600], [2, 3, 200]], src: 0, dst: 3, k: 1 }, 700],
    [{ n: 3, flights: [[0, 1, 100], [1, 2, 100], [0, 2, 500]], src: 0, dst: 2, k: 1 }, 200],
    [{ n: 3, flights: [[0, 1, 100], [1, 2, 100], [0, 2, 500]], src: 0, dst: 2, k: 0 }, 500],
  ]),
  P('combination-sum-ii', 'Combination Sum II', 'Medium', 'Return unique combinations that sum to target when each candidate can be used at most once. Sort each combination and the outer list.', [A.ints('candidates'), A.int('target')], 'intMatrix', { candidates: [10, 1, 2, 7, 6, 1, 5], target: 8 }, [[1, 1, 6], [1, 2, 5], [1, 7], [2, 6]], [
    [{ candidates: [10, 1, 2, 7, 6, 1, 5], target: 8 }, [[1, 1, 6], [1, 2, 5], [1, 7], [2, 6]]],
    [{ candidates: [2, 5, 2, 1, 2], target: 5 }, [[1, 2, 2], [5]]],
  ]),
  P('combination-sum-iii', 'Combination Sum III', 'Medium', 'Return all combinations of k distinct numbers from 1 through 9 that sum to n, sorted lexicographically.', [A.int('k'), A.int('n')], 'intMatrix', { k: 3, n: 7 }, [[1, 2, 4]], [
    [{ k: 3, n: 7 }, [[1, 2, 4]]],
    [{ k: 3, n: 9 }, [[1, 2, 6], [1, 3, 5], [2, 3, 4]]],
    [{ k: 4, n: 1 }, []],
  ]),
  P('combinations', 'Combinations', 'Medium', 'Return all k-number combinations chosen from 1 through n, sorted lexicographically.', [A.int('n'), A.int('k')], 'intMatrix', { n: 4, k: 2 }, [[1, 2], [1, 3], [1, 4], [2, 3], [2, 4], [3, 4]], [
    [{ n: 4, k: 2 }, [[1, 2], [1, 3], [1, 4], [2, 3], [2, 4], [3, 4]]],
    [{ n: 1, k: 1 }, [[1]]],
  ]),
  P('design-add-and-search-words-data-structure', 'Design Add and Search Words Data Structure', 'Medium', 'Simulate addWord and search operations where . matches any single character. Return booleans for search operations.', [A.strings('operations'), A.strings('words')], 'boolArray', { operations: ['addWord', 'addWord', 'addWord', 'search', 'search', 'search', 'search'], words: ['bad', 'dad', 'mad', 'pad', 'bad', '.ad', 'b..'] }, [false, true, true, true], [
    [{ operations: ['addWord', 'addWord', 'addWord', 'search', 'search', 'search', 'search'], words: ['bad', 'dad', 'mad', 'pad', 'bad', '.ad', 'b..'] }, [false, true, true, true]],
    [{ operations: ['addWord', 'search', 'search'], words: ['a', '.', 'a'] }, [true, true]],
  ]),
  P('find-eventual-safe-states', 'Find Eventual Safe States', 'Medium', 'Given a directed graph adjacency list, return all nodes that cannot reach a cycle, sorted ascending.', [A.matrix('graph')], 'intArray', { graph: [[1, 2], [2, 3], [5], [0], [5], [], []] }, [2, 4, 5, 6], [
    [{ graph: [[1, 2], [2, 3], [5], [0], [5], [], []] }, [2, 4, 5, 6]],
    [{ graph: [[1, 2, 3, 4], [1, 2], [3, 4], [0, 4], []] }, [4]],
  ]),
  P('fruit-into-baskets', 'Fruit Into Baskets', 'Medium', 'Return the length of the longest contiguous subarray containing at most two distinct values.', [A.ints('fruits')], 'int', { fruits: [1, 2, 1] }, 3, [
    [{ fruits: [1, 2, 1] }, 3],
    [{ fruits: [0, 1, 2, 2] }, 3],
    [{ fruits: [1, 2, 3, 2, 2] }, 4],
  ]),
  P('furthest-building-you-can-reach', 'Furthest Building You Can Reach', 'Medium', 'Given building heights, bricks, and ladders, return the furthest index reachable while paying positive climbs with bricks or ladders.', [A.ints('heights'), A.int('bricks'), A.int('ladders')], 'int', { heights: [4, 2, 7, 6, 9, 14, 12], bricks: 5, ladders: 1 }, 4, [
    [{ heights: [4, 2, 7, 6, 9, 14, 12], bricks: 5, ladders: 1 }, 4],
    [{ heights: [4, 12, 2, 7, 3, 18, 20, 3, 19], bricks: 10, ladders: 2 }, 7],
    [{ heights: [14, 3, 19, 3], bricks: 17, ladders: 0 }, 3],
  ]),
  P('implement-trie-ii-prefix-tree', 'Implement Trie II (Prefix Tree)', 'Medium', 'Simulate insert, countWordsEqualTo, countWordsStartingWith, and erase. Return counts from the two count operations.', [A.strings('operations'), A.strings('words')], 'intArray', { operations: ['insert', 'insert', 'countWordsEqualTo', 'countWordsStartingWith', 'erase', 'countWordsEqualTo'], words: ['apple', 'apple', 'apple', 'app', 'apple', 'apple'] }, [2, 2, 1], [
    [{ operations: ['insert', 'insert', 'countWordsEqualTo', 'countWordsStartingWith', 'erase', 'countWordsEqualTo'], words: ['apple', 'apple', 'apple', 'app', 'apple', 'apple'] }, [2, 2, 1]],
    [{ operations: ['insert', 'insert', 'countWordsStartingWith', 'erase', 'countWordsStartingWith'], words: ['app', 'apple', 'app', 'app', 'app'] }, [2, 1]],
  ]),
  P('k-radius-subarray-averages', 'K Radius Subarray Averages', 'Medium', 'For each index, return the integer average of the subarray centered there with radius k, or -1 when the full window does not fit.', [A.ints('nums'), A.int('k')], 'intArray', { nums: [7, 4, 3, 9, 1, 8, 5, 2, 6], k: 3 }, [-1, -1, -1, 5, 4, 4, -1, -1, -1], [
    [{ nums: [7, 4, 3, 9, 1, 8, 5, 2, 6], k: 3 }, [-1, -1, -1, 5, 4, 4, -1, -1, -1]],
    [{ nums: [100000], k: 0 }, [100000]],
    [{ nums: [8], k: 100000 }, [-1]],
  ]),
  P('longest-palindromic-subsequence', 'Longest Palindromic Subsequence', 'Medium', 'Return the length of the longest subsequence of s that is a palindrome.', [A.string('s')], 'int', { s: 'bbbab' }, 4, [
    [{ s: 'bbbab' }, 4],
    [{ s: 'cbbd' }, 2],
    [{ s: 'a' }, 1],
  ]),
  P('longest-substring-with-at-most-k-distinct-characters', 'Longest Substring with At Most K Distinct Characters', 'Medium', 'Return the length of the longest substring containing at most k distinct characters.', [A.string('s'), A.int('k')], 'int', { s: 'eceba', k: 2 }, 3, [
    [{ s: 'eceba', k: 2 }, 3],
    [{ s: 'aa', k: 1 }, 2],
    [{ s: 'a', k: 0 }, 0],
  ]),
  P('making-a-large-island', 'Making A Large Island', 'Hard', 'Given a binary grid, return the largest island area possible after changing at most one 0 to 1.', [A.matrix('grid')], 'int', { grid: [[1, 0], [0, 1]] }, 3, [
    [{ grid: [[1, 0], [0, 1]] }, 3],
    [{ grid: [[1, 1], [1, 0]] }, 4],
    [{ grid: [[1, 1], [1, 1]] }, 4],
  ]),
  P('minimum-cost-for-tickets', 'Minimum Cost For Tickets', 'Medium', 'Given travel days and pass costs [1-day,7-day,30-day], return the minimum total cost to cover all travel days.', [A.ints('days'), A.ints('costs')], 'int', { days: [1, 4, 6, 7, 8, 20], costs: [2, 7, 15] }, 11, [
    [{ days: [1, 4, 6, 7, 8, 20], costs: [2, 7, 15] }, 11],
    [{ days: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 30, 31], costs: [2, 7, 15] }, 17],
  ]),
  P('can-make-palindrome-from-substring', 'Can Make Palindrome from Substring', 'Medium', 'For each query [left,right,k], return true if the substring can be rearranged and changed in at most k positions to form a palindrome.', [A.string('s'), A.matrix('queries')], 'boolArray', { s: 'abcda', queries: [[3, 3, 0], [1, 2, 0], [0, 3, 1], [0, 3, 2], [0, 4, 1]] }, [true, false, false, true, true], [
    [{ s: 'abcda', queries: [[3, 3, 0], [1, 2, 0], [0, 3, 1], [0, 3, 2], [0, 4, 1]] }, [true, false, false, true, true]],
    [{ s: 'lyb', queries: [[0, 1, 0], [2, 2, 1]] }, [false, true]],
  ]),
  P('continuous-subarrays', 'Continuous Subarrays', 'Medium', 'Return the number of contiguous subarrays where the difference between the maximum and minimum value is at most 2.', [A.ints('nums')], 'int', { nums: [5, 4, 2, 4] }, 8, [
    [{ nums: [5, 4, 2, 4] }, 8],
    [{ nums: [1, 2, 3] }, 6],
    [{ nums: [65, 66, 67, 66, 66, 65, 64, 65, 65, 64] }, 43],
  ]),
  P('count-days-without-meetings', 'Count Days Without Meetings', 'Medium', 'Given days numbered 1 through days and meeting intervals [start,end], return how many days have no meeting scheduled.', [A.int('days'), A.matrix('meetings')], 'int', { days: 10, meetings: [[5, 7], [1, 3], [9, 10]] }, 2, [
    [{ days: 10, meetings: [[5, 7], [1, 3], [9, 10]] }, 2],
    [{ days: 5, meetings: [[2, 4], [1, 3]] }, 1],
    [{ days: 6, meetings: [[1, 6]] }, 0],
  ]),
  P('course-schedule-iv', 'Course Schedule IV', 'Medium', 'For each query [a,b], return true if course a is a prerequisite of course b.', [A.int('numCourses'), A.matrix('prerequisites'), A.matrix('queries')], 'boolArray', { numCourses: 2, prerequisites: [[1, 0]], queries: [[0, 1], [1, 0]] }, [false, true], [
    [{ numCourses: 2, prerequisites: [[1, 0]], queries: [[0, 1], [1, 0]] }, [false, true]],
    [{ numCourses: 3, prerequisites: [[1, 2], [1, 0], [2, 0]], queries: [[1, 0], [1, 2]] }, [true, true]],
  ]),
  P('divide-intervals-into-minimum-number-of-groups', 'Divide Intervals Into Minimum Number of Groups', 'Medium', 'Given inclusive intervals, return the minimum number of groups needed so intervals in each group do not overlap.', [A.matrix('intervals')], 'int', { intervals: [[5, 10], [6, 8], [1, 5], [2, 3], [1, 10]] }, 3, [
    [{ intervals: [[5, 10], [6, 8], [1, 5], [2, 3], [1, 10]] }, 3],
    [{ intervals: [[1, 3], [5, 6], [8, 10], [11, 13]] }, 1],
  ]),
  P('divide-players-into-teams-of-equal-skill', 'Divide Players Into Teams of Equal Skill', 'Medium', 'Pair players so every pair has the same total skill. Return the sum of pair chemistry products, or -1 if impossible.', [A.ints('skill')], 'int', { skill: [3, 2, 5, 1, 3, 4] }, 22, [
    [{ skill: [3, 2, 5, 1, 3, 4] }, 22],
    [{ skill: [3, 4] }, 12],
    [{ skill: [1, 1, 2, 3] }, -1],
  ]),
  P('domino-and-tromino-tiling', 'Domino and Tromino Tiling', 'Medium', 'Return the number of ways to tile a 2 by n board with dominoes and trominoes, modulo 1000000007.', [A.int('n')], 'int', { n: 3 }, 5, [
    [{ n: 1 }, 1],
    [{ n: 3 }, 5],
    [{ n: 8 }, 258],
  ]),
  P('find-the-k-beauty-of-a-number', 'Find the K-Beauty of a Number', 'Easy', 'Return how many length-k digit substrings of num are nonzero divisors of num.', [A.int('num'), A.int('k')], 'int', { num: 240, k: 2 }, 2, [
    [{ num: 240, k: 2 }, 2],
    [{ num: 430043, k: 2 }, 2],
    [{ num: 100, k: 1 }, 1],
  ]),
  P('find-the-kth-largest-integer-in-the-array', 'Find the Kth Largest Integer in the Array', 'Medium', 'Given non-negative integers encoded as strings, return the kth largest numeric value as a string.', [A.strings('nums'), A.int('k')], 'string', { nums: ['3', '6', '7', '10'], k: 4 }, '3', [
    [{ nums: ['3', '6', '7', '10'], k: 4 }, '3'],
    [{ nums: ['2', '21', '12', '1'], k: 3 }, '2'],
    [{ nums: ['0', '0'], k: 2 }, '0'],
  ]),
  P('find-the-original-array-of-prefix-xor', 'Find The Original Array of Prefix Xor', 'Medium', 'Given prefix xor values, return the original array that produced them.', [A.ints('pref')], 'intArray', { pref: [5, 2, 0, 3, 1] }, [5, 7, 2, 3, 2], [
    [{ pref: [5, 2, 0, 3, 1] }, [5, 7, 2, 3, 2]],
    [{ pref: [13] }, [13]],
  ]),
  P('frog-jump', 'Frog Jump', 'Hard', 'Given sorted stone positions, return true if the frog can cross by making jumps of k-1, k, or k+1 after a previous jump of k.', [A.ints('stones')], 'bool', { stones: [0, 1, 3, 5, 6, 8, 12, 17] }, true, [
    [{ stones: [0, 1, 3, 5, 6, 8, 12, 17] }, true],
    [{ stones: [0, 1, 2, 3, 4, 8, 9, 11] }, false],
  ]),
  P('k-empty-slots', 'K Empty Slots', 'Hard', 'Flowers bloom in the given order by position. Return the earliest day when two blooming flowers have exactly k unbloomed slots between them, or -1.', [A.ints('flowers'), A.int('k')], 'int', { flowers: [1, 3, 2], k: 1 }, 2, [
    [{ flowers: [1, 3, 2], k: 1 }, 2],
    [{ flowers: [1, 2, 3], k: 1 }, -1],
    [{ flowers: [6, 5, 8, 9, 7, 1, 10, 2, 3, 4], k: 2 }, 8],
  ]),
  P('knight-dialer', 'Knight Dialer', 'Medium', 'Return how many distinct phone numbers of length n can be dialed by moving a chess knight on a keypad, modulo 1000000007.', [A.int('n')], 'int', { n: 2 }, 20, [
    [{ n: 1 }, 10],
    [{ n: 2 }, 20],
    [{ n: 4 }, 104],
  ]),
  P('longest-continuous-subarray-with-absolute-diff-less-than-or-equal-to-limit', 'Longest Continuous Subarray With Absolute Diff Less Than or Equal to Limit', 'Medium', 'Return the longest contiguous subarray length whose maximum and minimum differ by at most limit.', [A.ints('nums'), A.int('limit')], 'int', { nums: [8, 2, 4, 7], limit: 4 }, 2, [
    [{ nums: [8, 2, 4, 7], limit: 4 }, 2],
    [{ nums: [10, 1, 2, 4, 7, 2], limit: 5 }, 4],
    [{ nums: [4, 2, 2, 2, 4, 4, 2, 2], limit: 0 }, 3],
  ]),
  P('make-sum-divisible-by-p', 'Make Sum Divisible by P', 'Medium', 'Remove the shortest non-empty subarray so the remaining sum is divisible by p. Return -1 if impossible.', [A.ints('nums'), A.int('p')], 'int', { nums: [3, 1, 4, 2], p: 6 }, 1, [
    [{ nums: [3, 1, 4, 2], p: 6 }, 1],
    [{ nums: [6, 3, 5, 2], p: 9 }, 2],
    [{ nums: [1, 2, 3], p: 3 }, 0],
  ]),
  P('meeting-rooms', 'Meeting Rooms', 'Easy', 'Given meeting intervals, return true if one person can attend every meeting without overlap.', [A.matrix('intervals')], 'bool', { intervals: [[0, 30], [5, 10], [15, 20]] }, false, [
    [{ intervals: [[0, 30], [5, 10], [15, 20]] }, false],
    [{ intervals: [[7, 10], [2, 4]] }, true],
    [{ intervals: [] }, true],
  ]),
  P('minimum-consecutive-cards-to-pick-up', 'Minimum Consecutive Cards to Pick Up', 'Medium', 'Return the length of the shortest contiguous subarray containing a repeated card value, or -1 if none exists.', [A.ints('cards')], 'int', { cards: [3, 4, 2, 3, 4, 7] }, 4, [
    [{ cards: [3, 4, 2, 3, 4, 7] }, 4],
    [{ cards: [1, 0, 5, 3] }, -1],
    [{ cards: [1, 1] }, 2],
  ]),
  P('minimum-falling-path-sum', 'Minimum Falling Path Sum', 'Medium', 'Given a square matrix, return the minimum sum of a falling path moving down one row and at most one column sideways each step.', [A.matrix('matrix')], 'int', { matrix: [[2, 1, 3], [6, 5, 4], [7, 8, 9]] }, 13, [
    [{ matrix: [[2, 1, 3], [6, 5, 4], [7, 8, 9]] }, 13],
    [{ matrix: [[-19, 57], [-40, -5]] }, -59],
  ]),
  P('minimum-genetic-mutation', 'Minimum Genetic Mutation', 'Medium', 'Return the minimum number of one-character mutations needed to reach endGene using only genes from bank, or -1.', [A.string('startGene'), A.string('endGene'), A.strings('bank')], 'int', { startGene: 'AACCGGTT', endGene: 'AACCGGTA', bank: ['AACCGGTA'] }, 1, [
    [{ startGene: 'AACCGGTT', endGene: 'AACCGGTA', bank: ['AACCGGTA'] }, 1],
    [{ startGene: 'AACCGGTT', endGene: 'AAACGGTA', bank: ['AACCGGTA', 'AACCGCTA', 'AAACGGTA'] }, 2],
    [{ startGene: 'AAAAACCC', endGene: 'AACCCCCC', bank: ['AAAACCCC', 'AAACCCCC', 'AACCCCCC'] }, 3],
  ]),
  P('minimum-window-substring', 'Minimum Window Substring', 'Hard', 'Return the shortest substring of s containing every character of t with multiplicity. Return an empty string if none exists.', [A.string('s'), A.string('t')], 'string', { s: 'ADOBECODEBANC', t: 'ABC' }, 'BANC', [
    [{ s: 'ADOBECODEBANC', t: 'ABC' }, 'BANC'],
    [{ s: 'a', t: 'a' }, 'a'],
    [{ s: 'a', t: 'aa' }, ''],
  ]),
  P('network-delay-time', 'Network Delay Time', 'Medium', 'Given directed edges [u,v,w] with 1-indexed nodes, return how long a signal from k takes to reach all nodes, or -1.', [A.matrix('times'), A.int('n'), A.int('k')], 'int', { times: [[2, 1, 1], [2, 3, 1], [3, 4, 1]], n: 4, k: 2 }, 2, [
    [{ times: [[2, 1, 1], [2, 3, 1], [3, 4, 1]], n: 4, k: 2 }, 2],
    [{ times: [[1, 2, 1]], n: 2, k: 1 }, 1],
    [{ times: [[1, 2, 1]], n: 2, k: 2 }, -1],
  ]),
  P('peak-index-in-a-mountain-array', 'Peak Index in a Mountain Array', 'Medium', 'Given a mountain array, return the index of the peak value.', [A.ints('arr')], 'int', { arr: [0, 2, 1, 0] }, 1, [
    [{ arr: [0, 1, 0] }, 1],
    [{ arr: [0, 2, 1, 0] }, 1],
    [{ arr: [0, 10, 5, 2] }, 1],
  ]),
  P('count-square-submatrices-with-all-ones', 'Count Square Submatrices with All Ones', 'Medium', 'Given a binary matrix, count all square submatrices that contain only ones.', [A.matrix('matrix')], 'int', { matrix: [[0, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1]] }, 15, [
    [{ matrix: [[0, 1, 1, 1], [1, 1, 1, 1], [0, 1, 1, 1]] }, 15],
    [{ matrix: [[1, 0, 1], [1, 1, 0], [1, 1, 0]] }, 7],
    [{ matrix: [[1]] }, 1],
  ]),
  P('01-matrix', '01 Matrix', 'Medium', 'Given a binary matrix, return a matrix where each cell stores its distance to the nearest zero.', [A.matrix('mat')], 'intMatrix', { mat: [[0, 0, 0], [0, 1, 0], [1, 1, 1]] }, [[0, 0, 0], [0, 1, 0], [1, 2, 1]], [
    [{ mat: [[0, 0, 0], [0, 1, 0], [1, 1, 1]] }, [[0, 0, 0], [0, 1, 0], [1, 2, 1]]],
    [{ mat: [[0, 0, 0], [0, 1, 0], [0, 0, 0]] }, [[0, 0, 0], [0, 1, 0], [0, 0, 0]]],
    [{ mat: [[1, 1, 1], [1, 0, 1], [1, 1, 1]] }, [[2, 1, 2], [1, 0, 1], [2, 1, 2]]],
  ]),
  P('count-nodes-equal-to-average-of-subtree', 'Count Nodes Equal to Average of Subtree', 'Medium', 'The tree is encoded as a level-order array where -1 means null. Return how many non-null nodes equal the integer average of their subtree.', [A.ints('values')], 'int', { values: [4, 8, 5, 0, 1, -1, 6] }, 5, [
    [{ values: [4, 8, 5, 0, 1, -1, 6] }, 5],
    [{ values: [1] }, 1],
    [{ values: [10, 5, 15, 5, 5, 15, 15] }, 7],
  ]),
  P('lowest-common-ancestor-of-a-binary-tree-iv', 'Lowest Common Ancestor of a Binary Tree IV', 'Medium', 'Given directed tree edges [parent, child], a root value, and target node values, return the value of their lowest common ancestor.', [A.matrix('edges'), A.int('root'), A.ints('nodes')], 'int', { edges: [[3, 5], [3, 1], [5, 6], [5, 2], [1, 0], [1, 8], [2, 7], [2, 4]], root: 3, nodes: [7, 4, 6] }, 5, [
    [{ edges: [[3, 5], [3, 1], [5, 6], [5, 2], [1, 0], [1, 8], [2, 7], [2, 4]], root: 3, nodes: [7, 4, 6] }, 5],
    [{ edges: [[1, 2], [1, 3], [2, 4], [2, 5]], root: 1, nodes: [4, 5] }, 2],
    [{ edges: [[1, 2], [1, 3], [2, 4], [2, 5]], root: 1, nodes: [4, 3] }, 1],
  ]),
  P('construct-quad-tree', 'Construct Quad Tree', 'Medium', 'Given a binary grid, return the preorder encoding of its compressed quad tree using 1 for leaf nodes and 0 for internal nodes.', [A.matrix('grid')], 'intArray', { grid: [[0, 1], [1, 0]] }, [0, 1, 0, 1, 1, 1, 1, 1, 0], [
    [{ grid: [[0, 1], [1, 0]] }, [0, 1, 0, 1, 1, 1, 1, 1, 0]],
    [{ grid: [[1, 1], [1, 1]] }, [1, 1]],
  ])
);

export default supplementalProblems;
